function Spinner({ type }) {
  return (
    <div
      className={`${type === 'growing' ? 'spinner-grow' : 'spinner-border'} text-primary m-1`}
      role="status"
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
}

export default Spinner;
